import React, { useState, useContext } from 'react';
//import useFormSubmission from "../../services/AuthService/AuthService";
import useFormSubmission from "../Controller/AuthController";
import { AuthModel } from "../Model/AuthModel";

import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import SuperAdminService from "../../SuperAdmin/Controller/Client/SACompanyListController";
function ForgetPassword() {
    localStorage.clear();
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const handleSubmit = useFormSubmission();

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const [errors, setErrors] = useState({});
    const [formData, setFormData] = AuthModel();
    const [errorMessage, setErrorMessage] = useState('');
    const onForgetPassword = async (event) => {
        debugger;
        event.preventDefault();

        const errors = {};

        if (!formData.FEmail || !formData.FEmail.trim()) {
            errors.FEmail = 'This field is required';
        }
        if (formData.FEmail) {
            if (!isValidEmail(formData.FEmail)) {
                errors.FEmail = 'Please enter a valid email address';
            }
        }
        if (Object.keys(errors).length === 0) {
            const response = await SuperAdminService.ForgetPassword(formData.FEmail);
            if (response.message === "Record not found") {
                errors.FEmail = 'The record with this email does not exist';
            }
            else if (response.message === "Email send successfully") {
                errors.FEmail = 'The password has been send successfuly to your email';
            }
        }
        setErrors(errors);

    };
    const isValidEmail = (email) => {
        // You can implement a regex or use a library like validator.js to validate email format
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    return (

        <div class="auth-main-content auth-bg-image">
            <div class="d-table">
                <div class="d-tablecell">
                    <div class="auth-box">
                        <div class="row align-items-center">

                            <div class="col-md-12">
                                <div class="form-content">
                                    <div class="auth-logo">
                                        <img src="assets/img/logo.png" alt="Logo" style={{ "width": "70%" }} />
                                    </div>

                                    <h1 class="heading">Forgot your password?</h1>
                                    {errorMessage && <p className="text-center small" style={{ color: 'red' }}>{errorMessage}</p>}
                                    <form class="" onSubmit={onForgetPassword}>
                                       <p>Please enter the account for which you want to reset the password.</p>
                                        <div class="form-group">
                                            <label class="form-label">User Name</label>

                                            <input type="text" className='form-control txtUserName' name="FEmail" value={formData.FEmail} onChange={handleFieldChange} />
                                            {errors.FEmail && <div style={{ color: 'red' }}>{errors.FEmail}</div>}
                                        </div>

                                        <div class="text-center mt-4">
                                            <button type="submit"  class="btn btn-primary btn-block btn-lg mt-3 rounded-pill">Submit</button>

                                        </div>

                                    </form>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ForgetPassword;
